











































































































import PartnerBatchUpdateDialog from "@/components/partner/PartnerBatchUpdateDialog.vue";
import PartnerCreateDialog from "@/components/partner/PartnerCreateDialog.vue";
import TheLayoutPortal from "@/layouts/TheLayoutPortal.vue";
import { getFlagEmoji } from "@/lib/CountryCodeHelper";
import { AppContextEnum } from "@/lib/enum/appContext.enum";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import { PartnerEntity } from "@/models/partnerEntity";
import { MrfiktivBookedServicesDtoGen } from "@/services/mrfiktiv/v1/data-contracts";
import { ActionEnum } from "@/store/enum/authActionEnum";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { UpdatePartnerDto } from "@/store/models/createPartnerDto";
import { ConfigModule } from "@/store/modules/config";
import { PartnerModule } from "@/store/modules/partner";
import { Component, Watch } from "vue-property-decorator";

@Component({
  components: {
    TheLayoutPortal,
    PartnerCreateDialog,
    PartnerBatchUpdateDialog
  },
  filters: {
    getFlagEmoji,
    simpleDoubleDigitDate
  }
})
export default class PartnerTable extends DarkModeHighlightMixin {
  isLoadingAllPartner = false;
  isLoading = false;

  search = "";

  selected: PartnerEntity[] = [];

  itemsPerPage = 25;

  snack = false;
  snackColor = "";
  snackText = "";

  expanded = [];

  ActionEnum = ActionEnum;
  ResourceEnum = ResourceEnum;

  get isTHGContext() {
    return ConfigModule.appContext === AppContextEnum.THG_PORTAL || ConfigModule.appContext === AppContextEnum.THG;
  }

  get headers() {
    if (this.isTHGContext)
      return [
        { text: this.$t("partner.PartnerTable.id"), align: "start", value: "_id", width: 200 },
        {
          text: this.$t("partner.PartnerTable.country"),
          value: "countryCode",
          width: 100,
          align: "center"
        },
        {
          text: this.$t("partner.PartnerTable.companyName"),
          value: "companyName",
          width: "33%"
        },
        {
          text: this.$t("partner.PartnerTable.cardTitle"),
          align: "start",
          value: "settings.cardTitle",
          width: "33%"
        },
        {
          text: this.$t("partner.PartnerTable.cardSubtitle"),
          align: "start",
          value: "settings.cardSubtitle",
          width: "33%"
        }
      ];

    return [
      { text: this.$t("objects.report.timestamp.created"), align: "start", value: "timestamps.created", width: 120 },
      { text: this.$t("partner.PartnerTable.id"), align: "start", value: "_id", width: 200 },
      {
        text: this.$t("components.template.editor.placeholder.path.partner.partnerTypeLabel"),
        value: "partnerType",
        width: 100,
        align: "center"
      },
      {
        text: this.$t("partner.PartnerTable.country"),
        value: "countryCode",
        width: 100,
        align: "center"
      },
      {
        text: this.$t("components.template.editor.placeholder.path.partner.languageCodeLabel"),
        value: "language",
        width: 100,
        align: "center"
      },
      {
        text: this.$t("objects.appraisal.currency"),
        value: "currency",
        width: 100,
        align: "center"
      },
      {
        text: this.$t("partner.PartnerTable.companyName"),
        value: "companyName"
      },
      {
        text: this.$t("components.partner.PartnerCreateOrUpdateLicense.bookedServices.domainsTitle"),
        value: "settings.defaultUrl"
      },
      {
        text: this.$t("components.partner.PartnerSettingsForm.inbox.title"),
        value: "settings.inboxes"
      },
      {
        text: this.$t("components.partner.PartnerCreateOrUpdateLicense.bookedServices.title"),
        value: "settings.bookedServices"
      }
    ];
  }

  async mounted() {
    await this.getPartners();
  }

  async getPartners() {
    this.isLoadingAllPartner = true;
    try {
      await PartnerModule.getPartners();
    } catch (error) {
      this.$log.error(error);
    } finally {
      this.isLoadingAllPartner = false;
    }
  }

  get partners(): PartnerEntity[] {
    return PartnerModule.partners;
  }

  async update(updatedPartner: PartnerEntity) {
    const dto = new UpdatePartnerDto(updatedPartner);
    this.isLoading = true;

    try {
      const updatePartner = await PartnerModule.updatePartner({
        id: updatedPartner._id,
        partnerUpdateEntity: dto
      });

      if (!updatePartner) {
        this.$toast.error("Fehler beim Ändern des Partners");
      } else {
        this.$toast.success("Partner erfolgreich geändert.");
      }
    } catch (error) {
      this.$log.error(error);
      this.$toast.error("Fehler beim Ändern des Partners");
    } finally {
      this.isLoading = false;
    }
  }

  cancel() {
    this.snack = true;
    this.snackColor = "info";
    this.snackText = "Abgebrochen";
  }

  open() {
    this.snack = true;
    this.snackColor = "info";
    this.snackText = "Ändern";
  }

  close() {
    this.$log.info("Dialog closed");
  }

  @Watch("selected")
  watchSelected() {
    this.$log.info(this.selected);
  }

  async selectFailed(partners: PartnerEntity[]) {
    await this.getPartners();
    this.selected = partners;
  }

  formatBookedServices(bookedServices: MrfiktivBookedServicesDtoGen | undefined): string {
    if (!bookedServices) return "";
    const entries = Object.entries(bookedServices as Record<string, boolean | undefined>);
    return entries.map(([k, v]) => `${k}: ${v ? "true" : "false"}`).join(", ");
  }
}
